import { useCardContextValue } from '../state/CardContext';
import { COMPANY_TYPE_ID, CONTACT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { usePropertyInputProps } from '../hooks/usePropertyInputProps';
import { PropertyInputsProvider } from '../state/PropertyInputsContext';
import ContactCompanyDetails from './ContactCompanyDetails';
import CrmObjectDetails from './CrmObjectDetails';
import { jsx as _jsx } from "react/jsx-runtime";
const RecordDetailsWithAvatar = ({
  isEditable = true
}) => {
  const {
    objectTypeId
  } = useCardContextValue();
  const propertyInputProps = usePropertyInputProps();
  return /*#__PURE__*/_jsx(PropertyInputsProvider, {
    value: propertyInputProps,
    children: objectTypeId === COMPANY_TYPE_ID || objectTypeId === CONTACT_TYPE_ID ? /*#__PURE__*/_jsx(ContactCompanyDetails, {
      isEditable: isEditable
    }) : /*#__PURE__*/_jsx(CrmObjectDetails, {
      isEditable: isEditable
    })
  });
};
export default RecordDetailsWithAvatar;